import axios from "axios";
import apiPath from "../constants/apiPath";

export const client = axios.create({
  baseURL: apiPath.baseURL,
  withCredentials: true,
});

let isRefreshing = false;
let refreshSubscribers = [];

const subscribeTokenRefresh = (resolve, reject) => {
  refreshSubscribers.push({ resolve, reject });
};

const notifyRefreshSubscribers = (error) => {
  refreshSubscribers.forEach(({ resolve, reject }) => {
    if (error) reject(error);
    else resolve();
  });
  refreshSubscribers = [];
};

client.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    const status = error?.response?.status;
    const isAuthError = status === 401 || status === 403 || error?.response?.data?.statusText === "JWT_EXPIRED";

    if (!originalRequest || originalRequest._retry || !isAuthError || originalRequest.url?.includes("refresh-token") || originalRequest.url?.includes("login")) {
      return Promise.reject(error);
    }

    originalRequest._retry = true;

    if (isRefreshing) {
      return new Promise((resolve, reject) => {
        subscribeTokenRefresh(
          () => resolve(client(originalRequest)),
          (refreshError) => reject(refreshError),
        );
      });
    }

    isRefreshing = true;

    try {
      await client.post(apiPath.refreshToken);
      notifyRefreshSubscribers();
      return client(originalRequest);
    } catch (refreshError) {
      notifyRefreshSubscribers(refreshError);
      return Promise.reject(refreshError);
    } finally {
      isRefreshing = false;
    }
  },
);
